import _ from "lodash";

export function mapValues<U, O, K extends keyof U>(
    o: U,
    f: (value: U[K], key: K, obj: U) => O
): Record<keyof U, O> {
    return _.mapValues(o as any, f) as any;
}
export const asReadonly = _.identity as <T>(t: T) => Readonly<T>;

export type Primitive = string | number | boolean;

export type Predicate<T> = (x: T) => boolean;
export type Many<T> = T | T[];

export type ArrayContents<T extends any[]> = T[number];

export function assert(value: any, errorMessage: string): asserts value {
    if (!value) {
        throw new Error(`Assertion failed - ${errorMessage}`);
    }
}
export function assertNever(value: never): never {
    throw new Error(
        `Unhandled discriminated union member ${JSON.stringify(value)}`
    );
}

export function isNotNil<T>(x: T | undefined | null): x is T {
    return x !== null && x !== undefined;
}

export function isNotFalsy<T>(
    x: T | undefined | null | 0 | false | ""
): x is T {
    return !!x;
}

export type DistributedOmit<T, K extends keyof T> = T extends any
    ? Omit<T, K>
    : never;

// Gets all potential keys of a union.  The `T extends any` bit makes this a distributive conditional.
type AllKeys<T> = T extends any ? keyof T : never;

// Gets the type for a key, or undefined if it's not a valid key.  (Also a distributive conditional type)
type GetType<T, K extends string> = T extends Partial<Record<K, any>>
    ? T[K]
    : undefined;

// Converts a union into a single flattened type
export type FlattenUnion<T> = {
    [K in AllKeys<T> & string]: GetType<T, K>;
};
